import { render, staticRenderFns } from "./addThirdOrder.vue?vue&type=template&id=39617e80&scoped=true"
import script from "./addThirdOrder.vue?vue&type=script&lang=js"
export * from "./addThirdOrder.vue?vue&type=script&lang=js"
import style0 from "./addThirdOrder.vue?vue&type=style&index=0&id=39617e80&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39617e80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39617e80')) {
      api.createRecord('39617e80', component.options)
    } else {
      api.reload('39617e80', component.options)
    }
    module.hot.accept("./addThirdOrder.vue?vue&type=template&id=39617e80&scoped=true", function () {
      api.rerender('39617e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/order/addThirdOrder.vue"
export default component.exports